import * as actionTypes from '../types/tn';

const initialState = {
  dateTN: '' || null,
  docNum: null,
  docNumId: null,
  savedData: {
    docNumId: null,
    tnDate: '' || null,
    docNum: null,
    actualTnDate: '' || null,
    vehicleId: null
  },
  docType: null,
  docStatus: null,
  driverMiddleName: null,
  driverName: null,
  driverLastName: null,
  loadingTN: false,
  note: null,
  numberTN: null,
  packingType: null,
  tnExist: false,
  supportingDocuments: null,
  isExpeditor: 'Y',
  separationWeight: 0,
  savingTN: {
    loading: false,
    success: false
  },
  updateTn: {
    loading: false,
    success: false,
    updateByModal: false,
    updateTnFromTab: false
  },
  confirmTn: {
    loading: false,
    success: false
  },
  deleteTn: {
    loading: false,
    success: false
  },
  vehicleList: {
    data: [],
    loading: false,
    success: false
  },
  driverList: {
    data: [],
    loading: false,
    success: false
  },
  packingTypeList: {
    data: [],
    loading: false,
    success: false
  },
  tnList: {
    data: [],
    loading: false,
    success: false,
    confirmLoading: false,
    okUpdate: false
  },
  tnPieceList: {
    data: [],
    loading: false,
    success: false
  },
  responsiblePersonList: {
    data: [],
    loading: false,
    success: false
  },
  transportCompanyList: {
    data: [],
    loading: false,
    success: false
  },
  addPiece: {
    loading: false,
    success: false
  },
  deletePiece: {
    loading: false,
    success: false
  },
  addDriver: {
    loading: false,
    success: false
  },
  addVehicle: {
    loading: false,
    success: false
  },
  addPackingType: {
    loading: false,
    success: false
  },
  addResponsiblePerson: {
    loading: false,
    success: false
  },
  addTransportCompany: {
    loading: false,
    success: false
  },
  deleteEntity: {
    loading: false,
    success: false
  },
  vehicleForm: {
    model: null,
    num: null,
    vehicleNumId: null
  },
  trailerForm: {
    num: null,
    vehicleNumId: null
  },
  driverForm: {
    driverNumId: null,
    documentNumber: null,
    documentType: null,
    documentTypeNum: null,
    familyName: null,
    givenName: null,
    middleName: null,
    fullName: null,
    fullNameShort: null
  },
  packingTypeForm: {
    name: null,
    packingTypeNumId: null
  },
  responsiblePersonForm: {
    fullName: null,
    post: null,
    id: null
  },
  transportCompanyForm: {
    name: null,
    address: null,
    inn: null,
    id: null
  },
  loadedModal: {
    TN: false,
    vehicle: false,
    vehicleAdd: false,
    driver: false,
    driverAdd: false,
    packingType: false,
    packingTypeAdd: false,
    tnList: false,
    responsiblePerson: false,
    responsiblePersonAdd: false,
    transportCompany: false,
    transportCompanyAdd: false
  },
  visibleModal: {
    TN: false,
    vehicle: false,
    vehicleAdd: false,
    driver: false,
    driverAdd: false,
    packingType: false,
    packingTypeAdd: false,
    tnList: false,
    responsiblePerson: false,
    responsiblePersonAdd: false,
    transportCompany: false,
    transportCompanyAdd: false
  },
  modalDriverMode: 'vehicle',
  nextNumber: {
    loading: false,
    success: false
  }
};

const reducer = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case actionTypes.MODAL_TN_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          TN: true
        },
        loadedModal: {
          ...state.loadedModal,
          TN: true
        },
        updateTn: {
          ...state.updateTn,
          updateTnFromTab: (payload?.updateTnFromTab) ? payload.updateTnFromTab : false
        }
      };
    case actionTypes.MODAL_TN_CLOSE:
      return {
        ...initialState,
        savedData: {
          ...state.savedData,
          docNumId: state.savedData.docNumId,
          tnDate: state.savedData.tnDate,
          docNum: state.savedData.docNum,
          actualTnDate: state.savedData.actualTnDate,
          vehicleId: state.savedData.vehicleId
        },
        docNumId: state.docNumId,
        numberTN: state.numberTN,
        vehicleForm: {
          num: state.vehicleForm.num
        },
        visibleModal: {
          ...state.visibleModal,
          TN: false
        },
        loadedModal: {
          ...initialState.loadedModal,
          TN: true
        },
        updateTn: state.updateTn
      };
    case actionTypes.MODAL_VEHICLE_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          vehicle: true
        },
        loadedModal: {
          ...state.loadedModal,
          vehicle: true
        },
        modalDriverMode: payload
      };
    case actionTypes.MODAL_VEHICLE_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          vehicle: false
        },
        modalDriverMode: initialState.modalDriverMode
      };
    case actionTypes.GET_VEHICLES_LIST:
      return {
        ...state,
        vehicleList: {
          ...state.vehicleList,
          loading: true,
          data: [],
          success: false
        }
      };
    case actionTypes.GET_VEHICLES_LIST_SUCCESS:
      return {
        ...state,
        vehicleList: {
          ...state.vehicleList,
          loading: false,
          data: payload,
          success: true
        }
      };
    case actionTypes.GET_VEHICLES_LIST_FAIL:
      return {
        ...state,
        vehicleList: {
          ...state.vehicleList,
          loading: false,
          data: [],
          success: false
        }
      };
    case actionTypes.SET_DATE_TN:
      return {
        ...state,
        dateTN: payload
      };
    case actionTypes.SET_SAVED_DATA:
      return {
        ...state,
        savedData: payload
      };
    case actionTypes.MODAL_VEHICLE_ADD_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          vehicleAdd: true
        },
        loadedModal: {
          ...state.loadedModal,
          vehicleAdd: true
        }
      };
    case actionTypes.MODAL_VEHICLE_ADD_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          vehicleAdd: false
        }
      };
    case actionTypes.ADD_VEHICLE:
      return {
        ...state,
        addVehicle: {
          ...state.addVehicle,
          loading: true,
          success: false
        }
      };
    case actionTypes.ADD_VEHICLE_SUCCESS:
      return {
        ...state,
        addVehicle: {
          ...state.addVehicle,
          loading: false,
          success: true
        }
      };
    case actionTypes.ADD_VEHICLE_FAIL:
      return {
        ...state,
        addVehicle: {
          ...state.addVehicle,
          loading: false,
          success: false
        }
      };
    case actionTypes.SET_VEHICLE_FORM:
      return {
        ...state,
        vehicleForm: {
          ...state.vehicleForm,
          ...payload
        }
      };
    case actionTypes.MODAL_DRIVERS_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          driver: true
        },
        loadedModal: {
          ...state.loadedModal,
          driver: true
        }
      };
    case actionTypes.MODAL_DRIVERS_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          driver: false
        }
      };
    case actionTypes.GET_DRIVERS_LIST:
      return {
        ...state,
        driverList: {
          ...state.driverList,
          loading: true,
          success: false,
          data: []
        }
      };
    case actionTypes.GET_DRIVERS_LIST_SUCCESS:
      return {
        ...state,
        driverList: {
          ...state.driverList,
          loading: false,
          success: true,
          data: payload
        }
      };
    case actionTypes.GET_DRIVERS_LIST_FAIL:
      return {
        ...state,
        driverList: {
          ...state.driverList,
          loading: false,
          success: false,
          data: []
        }
      };
    case actionTypes.MODAL_ADD_DRIVER_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          driverAdd: true
        },
        loadedModal: {
          ...state.loadedModal,
          driverAdd: true
        }
      };
    case actionTypes.MODAL_ADD_DRIVER_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          driverAdd: false
        }
      };
    case actionTypes.ADD_DRIVER:
      return {
        ...state,
        addDriver: {
          ...state.addDriver,
          loading: true,
          success: false
        }
      };
    case actionTypes.ADD_DRIVER_SUCCESS:
      return {
        ...state,
        addDriver: {
          ...state.addDriver,
          loading: false,
          success: true
        }
      };
    case actionTypes.ADD_DRIVER_FAIL:
      return {
        ...state,
        addDriver: {
          ...state.addDriver,
          loading: false,
          success: false
        }
      };
    case actionTypes.SET_DRIVER_FORM:
      return {
        ...state,
        driverForm: {
          ...state.driverForm,
          ...payload
        }
      };
    case actionTypes.MODAL_PACKING_TYPE_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          packingType: true
        },
        loadedModal: {
          ...state.loadedModal,
          packingType: true
        }
      };
    case actionTypes.MODAL_PACKING_TYPE_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          packingType: false
        }
      };
    case actionTypes.MODAL_ADD_PACKING_TYPE_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          packingTypeAdd: true
        },
        loadedModal: {
          ...state.loadedModal,
          packingTypeAdd: true
        }
      };
    case actionTypes.MODAL_ADD_PACKING_TYPE_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          packingTypeAdd: false
        }
      };
    case actionTypes.GET_PACKING_TYPE_LIST:
      return {
        ...state,
        packingTypeList: {
          ...state.packingTypeList,
          loading: true,
          success: false,
          data: []
        }
      };
    case actionTypes.GET_PACKING_TYPE_LIST_SUCCESS:
      return {
        ...state,
        packingTypeList: {
          ...state.packingTypeList,
          loading: false,
          success: true,
          data: payload
        }
      };
    case actionTypes.GET_PACKING_TYPE_LIST_FAIL:
      return {
        ...state,
        packingTypeList: {
          ...state.packingTypeList,
          loading: false,
          success: false,
          data: []
        }
      };
    case actionTypes.ADD_PACKING_TYPE:
      return {
        ...state,
        addPackingType: {
          ...state.addPackingType,
          loading: true,
          success: false
        }
      };
    case actionTypes.ADD_PACKING_TYPE_SUCCESS:
      return {
        ...state,
        addPackingType: {
          ...state.addPackingType,
          loading: false,
          success: true
        }
      };
    case actionTypes.ADD_PACKING_TYPE_FAIL:
      return {
        ...state,
        addPackingType: {
          ...state.addPackingType,
          loading: false,
          success: false
        }
      };
    case actionTypes.SET_PACKING_TYPE_FORM:
      return {
        ...state,
        packingTypeForm: {
          ...state.packingTypeForm,
          ...payload
        }
      };
    case actionTypes.SET_NOTE_TN:
      return {
        ...state,
        note: payload
      };
    case actionTypes.SET_NUMBER_TN:
      return {
        ...state,
        numberTN: payload
      };
    case actionTypes.SAVE_TN:
      return {
        ...state,
        savingTN: {
          loading: true,
          success: false
        }
      };
    case actionTypes.SAVE_TN_SUCCESS:
      return {
        ...state,
        savingTN: {
          loading: false,
          success: true
        },
        tnExist: false,
        savedData: {
          ...state.savedData,
          docNumId: payload,
          tnDate: state.dateTN,
          docNum: state.numberTN,
          actualTnDate: state.dateTN,
          vehicleId: state.trailerForm.vehicleNumId ? `${state.vehicleForm.num}/${state.trailerForm.num}` : `${state.vehicleForm.num || ''}`
        }
      };
    case actionTypes.SAVE_TN_FAIL:
      return {
        ...state,
        savingTN: {
          loading: false,
          success: false
        }
      };
    case actionTypes.MODAL_TN_LIST_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          tnList: true
        },
        loadedModal: {
          ...state.loadedModal,
          tnList: true
        }
      };
    case actionTypes.MODAL_TN_LIST_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          tnList: false
        }
      };
    case actionTypes.GET_TN_LIST_UPDATE:
      return {
        ...state,
        tnList: {
          ...state.tnList,
          okUpdate: true
        }
      };
    case actionTypes.GET_TN_LIST:
      return {
        ...state,
        tnList: {
          ...state.tnList,
          loading: true,
          success: false,
          okUpdate: false
        }
      };
    case actionTypes.GET_TN_LIST_SUCCESS:
      return {
        ...state,
        tnList: {
          data: payload,
          loading: false,
          success: true,
          okUpdate: false
        }
      };
    case actionTypes.GET_TN_LIST_FAIL:
      return {
        ...state,
        tnList: {
          ...state.tnList,
          loading: false,
          success: false,
          okUpdate: false
        }
      };
    case actionTypes.SET_TN:
      return {
        ...state,
        tnList: {
          ...state.tnList,
          confirmLoading: true
        },
        updateTn: {
          ...state.updateTn,
          // updateTnFromTab: payload.updateTnFromTab
        }
      };
    case actionTypes.SET_TN_SUCCESS:
      return {
        ...state,
        dateTN: payload.dateTn,
        numberTN: payload.docNum,
        docNumId: payload.docNumId,
        docStatus: payload.docStatus,
        note: payload.note,
        vehicleForm: {
          vehicleNumId: payload.vehicleNumId,
          model: payload.vehicleBrand,
          num: payload.vehicleId
        },
        driverForm: {
          driverNumId: payload.driverNumId,
          givenName: payload.givenName,
          familyName: payload.familyName,
          middleName: payload.middleName,
          documentNumber: payload.documentNumber,
          documentTypeNum: payload.documentType,
          documentType: payload.documentTypeName,
          fullName: payload.driverName,
          fullNameShort: payload.driverNameShort
        },
        packingTypeForm: {
          name: payload.packingType,
          packingTypeNumId: payload.packingTypeNumId
        },
        trailerForm: {
          num: payload.trailerNum,
          vehicleNumId: payload.trailerNumId
        },
        responsiblePersonForm: {
          fullName: payload.fullName,
          id: payload.responsiblePersonNumId,
          post: payload.position
        },
        transportCompanyForm: {
          name: payload.transportCompanyName,
          id: payload.transportCompanyNumId,
          inn: payload.inn,
          address: payload.address
        },
        isExpeditor: payload.expeditorFlag,
        supportingDocuments: payload.shippingDocuments,
        separationWeight: payload.weightSeparation,
        visibleModal: {
          ...state.visibleModal,
          tnList: false
        },
        tnExist: true,
        tnList: {
          ...state.tnList,
          confirmLoading: false
        }
      };
    case actionTypes.GET_TN_PIECE_LIST:
      return {
        ...state,
        tnPieceList: {
          ...state.tnPieceList,
          loading: true,
          success: false
        }
      };
    case actionTypes.GET_TN_PIECE_LIST_SUCCESS:
      return {
        ...state,
        tnPieceList: {
          data: payload,
          loading: false,
          success: true
        }
      };
    case actionTypes.GET_TN_PIECE_LIST_FAIL:
      return {
        ...state,
        tnPieceList: {
          data: [],
          loading: false,
          success: false
        }
      };
    case actionTypes.ADD_PIECE_TO_TN:
      return {
        ...state,
        addPiece: {
          loading: true,
          success: false
        }
      };
    case actionTypes.ADD_PIECE_TO_TN_SUCCESS:
      return {
        ...state,
        addPiece: {
          loading: false,
          success: true
        }
      };
    case actionTypes.ADD_PIECE_TO_TN_FAIL:
      return {
        ...state,
        addPiece: {
          loading: false,
          success: false
        }
      };
    case actionTypes.UPDATE_TN:
      return {
        ...state,
        updateTn: {
          ...state.updateTn,
          loading: true,
          success: false,
          updateByModal: false
        }
      };
    case actionTypes.UPDATE_TN_SUCCESS:
      return {
        ...state,
        updateTn: {
          ...state.updateTn,
          loading: false,
          success: true,
          updateByModal: payload.updateByModal
        },
        savedData: {
          ...state.savedData,
          docNumId: state.docNumId,
          tnDate: state.dateTN,
          docNum: state.numberTN,
          actualTnDate: state.dateTN,
          vehicleId: state.vehicleForm.num
        }
      };
    case actionTypes.UPDATE_TN_FAIL:
      return {
        ...state,
        updateTn: {
          ...state.updateTn,
          loading: false,
          success: false,
          updateByModal: false
        }
      };
    case actionTypes.CONFIRM_TN:
      return {
        ...state,
        confirmTn: {
          loading: true,
          success: false
        }
      };
    case actionTypes.CONFIRM_TN_SUCCESS:
      return {
        ...state,
        confirmTn: {
          loading: false,
          success: true
        }
      };
    case actionTypes.CONFIRM_TN_FAIL:
      return {
        ...state,
        confirmTn: {
          loading: false,
          success: false
        }
      };
    case actionTypes.DELETE_PIECE_FROM_TN:
      return {
        ...state,
        deletePiece: {
          loading: true,
          success: false
        }
      };
    case actionTypes.DELETE_PIECE_FROM_TN_SUCCESS:
      return {
        ...state,
        deletePiece: {
          loading: false,
          success: true
        }
      };
    case actionTypes.DELETE_PIECE_FROM_TN_FAIL:
      return {
        ...state,
        deletePiece: {
          loading: false,
          success: false
        }
      };
    case actionTypes.DELETE_TN:
      return {
        ...state,
        deleteTn: {
          loading: true,
          success: false
        }
      };
    case actionTypes.DELETE_TN_SUCCESS:
      return {
        ...state,
        deleteTn: {
          loading: false,
          success: true
        }
      };
    case actionTypes.DELETE_TN_FAIL:
      return {
        ...state,
        deleteTn: {
          loading: false,
          success: false
        }
      };
    case actionTypes.GET_TTN_NEXT_NUMBER:
      return {
        ...state,
        nextNumber: {
          loading: true,
          success: false
        },
        numberTN: null
      };
    case actionTypes.GET_TTN_NEXT_NUMBER_SUCCESS:
      return {
        ...state,
        nextNumber: {
          loading: false,
          success: true
        },
        numberTN: payload
      };
    case actionTypes.GET_TTN_NEXT_NUMBER_FAIL:
      return {
        ...state,
        nextNumber: {
          loading: false,
          success: false
        },
        numberTN: null
      };
    case actionTypes.SET_IS_EXPEDITOR:
      return {
        ...state,
        isExpeditor: payload
      };
    case actionTypes.SET_SEPARATION_WEIGHT:
      return {
        ...state,
        separationWeight: payload
      };
    case actionTypes.SET_TRAILER_FORM:
      return {
        ...state,
        trailerForm: {
          ...state.trailerForm,
          ...payload
        }
      };
    case actionTypes.SET_SUPPORTING_DOCUMENTS:
      return {
        ...state,
        supportingDocuments: payload
      };
    case actionTypes.SET_TRANSPORT_COMPANY_FORM:
      return {
        ...state,
        transportCompanyForm: {
          name: payload.name,
          id: payload.id,
          inn: payload.inn,
          address: payload.address
        }
      };
    case actionTypes.MODAL_RESPONSIBLE_PERSON_OPEN:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          responsiblePerson: true
        },
        loadedModal: {
          ...state.loadedModal,
          responsiblePerson: true
        }
      };
    case actionTypes.MODAL_RESPONSIBLE_PERSON_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          responsiblePerson: false
        }
      };
    case actionTypes.SET_RESPONSIBLE_PERSON_FORM:
      return {
        ...state,
        responsiblePersonForm: {
          fullName: payload.fullName,
          id: payload.id,
          post: payload.post
        }
      };
    case actionTypes.MODAL_RESPONSIBLE_PERSON_ADD_OPEN:
      return {
        ...state,
        loadedModal: {
          ...state.loadedModal,
          responsiblePersonAdd: true
        },
        visibleModal: {
          ...state.visibleModal,
          responsiblePersonAdd: true
        }
      };
    case actionTypes.MODAL_RESPONSIBLE_PERSON_ADD_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          responsiblePersonAdd: false
        }
      };
    case actionTypes.GET_TRANSPORT_COMPANY_LIST:
      return {
        ...state,
        transportCompanyList: {
          ...state.transportCompanyList,
          loading: true,
          success: false
        }
      };
    case actionTypes.GET_TRANSPORT_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        transportCompanyList: {
          data: payload,
          loading: false,
          success: true
        }
      };
    case actionTypes.GET_TRANSPORT_COMPANY_LIST_FAIL:
      return {
        ...state,
        transportCompanyList: {
          data: [],
          loading: false,
          success: false
        }
      };
    case actionTypes.MODAL_TRANSPORT_COMPANY_OPEN:
      return {
        ...state,
        loadedModal: {
          ...state.loadedModal,
          transportCompany: true
        },
        visibleModal: {
          ...state.visibleModal,
          transportCompany: true
        }
      };
    case actionTypes.MODAL_TRANSPORT_COMPANY_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          transportCompany: false
        }
      };
    case actionTypes.ADD_TRANSPORT_COMPANY:
      return {
        ...state,
        addTransportCompany: {
          loading: true,
          success: false
        }
      };
    case actionTypes.ADD_TRANSPORT_COMPANY_SUCCESS:
      return {
        ...state,
        addTransportCompany: {
          loading: false,
          success: true
        }
      };
    case actionTypes.ADD_TRANSPORT_COMPANY_FAIL:
      return {
        ...state,
        addTransportCompany: {
          loading: false,
          success: false
        }
      };
    case actionTypes.MODAL_TRANSPORT_COMPANY_ADD_OPEN:
      return {
        ...state,
        loadedModal: {
          ...state.loadedModal,
          transportCompanyAdd: true
        },
        visibleModal: {
          ...state.visibleModal,
          transportCompanyAdd: true
        }
      };
    case actionTypes.MODAL_TRANSPORT_COMPANY_ADD_CLOSE:
      return {
        ...state,
        visibleModal: {
          ...state.visibleModal,
          transportCompanyAdd: false
        }
      };
    case actionTypes.GET_RESPONSIBLE_PERSON_LIST:
      return {
        ...state,
        responsiblePersonList: {
          ...state.responsiblePersonList,
          loading: true,
          success: false
        }
      };
    case actionTypes.GET_RESPONSIBLE_PERSON_LIST_SUCCESS:
      return {
        ...state,
        responsiblePersonList: {
          data: payload,
          loading: false,
          success: true
        }
      };
    case actionTypes.GET_RESPONSIBLE_PERSON_LIST_FAIL:
      return {
        ...state,
        responsiblePersonList: {
          data: [],
          loading: false,
          success: false
        }
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_TN:
      return {
        ...state,
        addResponsiblePerson: {
          loading: true,
          success: false
        }
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_TN_SUCCESS:
      return {
        ...state,
        addResponsiblePerson: {
          loading: false,
          success: true
        }
      };
    case actionTypes.ADD_RESPONSIBLE_PERSON_TN_FAIL:
      return {
        ...state,
        addResponsiblePerson: {
          loading: false,
          success: false
        }
      };
    case actionTypes.DELETE_ENTITY:
      return {
        ...state,
        deleteEntity: {
          loading: true,
          success: false
        }
      };
    case actionTypes.DELETE_ENTITY_SUCCESS:
      return {
        ...state,
        deleteEntity: {
          loading: false,
          success: true
        }
      };
    case actionTypes.DELETE_ENTITY_FAIL:
      return {
        ...state,
        deleteEntity: {
          loading: false,
          success: false
        }
      };
    case actionTypes.SET_INITIAL_STATE_TN:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default reducer;
